import React from "react";
import { Badge, Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const useMapStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    border: "1px dashed",
    borderRadius: theme.spacing(1),
    borderColor: grey[400],
    padding: theme.spacing(1),
    minHeight: theme.spacing(8),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  item: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(0.5),
  },
  avatar: {
    "&:hover": {
      cursor: "grab",
    },
    fontWeight: "bold",
    color: "#ffffff",
    borderRadius: 8,
    display: "flex",
    justifyContent: "space-between",
    minWidth: "6rem",
  },
}));

export const BulkLocationMap = ({
  aisle,
  handleBulkLocationClick,
  confirmDeleteLocation,
}) => {
  const classes = useMapStyles();

  const getBadgeContent = (location) => {
    if (location.productId)
      return (
        location.productName && location.productName.trim().substring(0, 3)
      );
    return null;
  };

  return (
    <div className={classes.container}>
      {aisle.locations.items.map((location) => (
        <div key={location.id} className={classes.item}>
          <Badge badgeContent={getBadgeContent(location)} color="primary">
            <Chip
              label={location.name || location.position}
              draggable="true"
              clickable
              onClick={() => handleBulkLocationClick(location)}
              onDelete={() => confirmDeleteLocation(location)}
              className={classes.avatar}
              style={{
                backgroundColor: location.zone?.color
                  ? location.zone.color
                  : "#90A4AE",
              }}
            />
          </Badge>
        </div>
      ))}
    </div>
  );
};
